import { useState } from "react";
import { DEFAULTS, META, isDefault, loadParams, saveParams, type ParamSet } from "../lib/settings";
import { linkHandler } from "../lib/router";

/** Настройки (ТЗ 3.3): набор параметров расчёта с меткой источника каждого порога (книга / по умолчанию). */
export function SettingsPage() {
  const [p, setP] = useState<ParamSet>(() => loadParams());
  const [saved, setSaved] = useState(false);
  const set = <K extends keyof ParamSet>(k: K, v: ParamSet[K]) => {
    setP((x) => ({ ...x, [k]: v }));
    setSaved(false);
  };
  return (
    <main className="page settings">
      <a className="back" href="/ru" onClick={linkHandler("/ru")}>
        ← Все рынки
      </a>
      <h1>Настройки параметров</h1>
      <p className="lede">
        Набор параметров применяется к графикам рынков и исследованиям в этом браузере. Сканер, журнал всех рынков и
        сигналы в базе считаются с набором по умолчанию — так результаты разных пользователей сравнимы. Метка
        «книга» — значение задано автором, «по умолчанию» — в книге числа нет (ТЗ 4.1).
      </p>
      <p className="lede">
        Правила сделок по умолчанию — «Сетап 4+ · 3 ATR» (вход по полному сетапу из индикаторов Уильямса); канон с входом
        по линии тренда — для сравнения в «Активных сделках» и бэктесте. Окна и пороги ниже — параметры индикаторов;
        значения по умолчанию взяты из книги.
      </p>
      <section>
        {META.map((m) => (
          <div className="param-row" key={m.key}>
            <label htmlFor={`p-${m.key}`}>
              {m.label}
              {m.hint && <small>{m.hint}</small>}
            </label>
            <span>
              {m.kind === "bool" ? (
                <input
                  id={`p-${m.key}`}
                  type="checkbox"
                  checked={Boolean(p[m.key])}
                  onChange={(e) => set(m.key, e.target.checked as never)}
                />
              ) : m.kind === "enum" ? (
                <select id={`p-${m.key}`} value={String(p[m.key])} onChange={(e) => set(m.key, e.target.value as never)}>
                  {m.options!.map(([v, t]) => (
                    <option key={v} value={v}>
                      {t}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  id={`p-${m.key}`}
                  type="number"
                  min={m.min}
                  max={m.max}
                  step={m.kind === "int" ? 1 : "any"}
                  value={Number(p[m.key])}
                  onChange={(e) => {
                    const v = Number(e.target.value);
                    if (!Number.isFinite(v)) return;
                    const clamped = Math.max(m.min ?? -Infinity, Math.min(m.max ?? Infinity, v));
                    set(m.key, (m.kind === "int" ? Math.round(clamped) : clamped) as never);
                  }}
                />
              )}
            </span>
            <span className={`src ${m.source === "книга" ? "book" : ""}`}>
              {m.module}, {m.source}
              {p[m.key] !== DEFAULTS[m.key] ? ` (по умолчанию ${String(DEFAULTS[m.key])})` : ""}
            </span>
          </div>
        ))}
      </section>
      <section className="controls">
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            saveParams(p);
            setSaved(true);
          }}
        >
          Сохранить
        </button>{" "}
        <button
          type="button"
          className="btn btn-ghost"
          onClick={() => {
            setP({ ...DEFAULTS });
            saveParams({ ...DEFAULTS });
            setSaved(true);
          }}
        >
          Вернуть значения по умолчанию
        </button>{" "}
        {saved && <span className="muted">{isDefault(p) ? "Сохранено: набор по умолчанию" : "Сохранено"}</span>}
      </section>
      <p className="muted">
        Уведомления о сигналах (ТЗ 3.3) появятся вместе с переносом Telegram-бота на этот сервис; сигналы уже пишутся в
        журнал базы после каждой ежедневной загрузки.
      </p>
    </main>
  );
}
